import React from 'react';

import ProductionBomShowView from '@components/shared/production_boms/ProductionBomShowView';
import { useLoaderData } from 'react-router-dom';

export default function OperatorProductionBomShow() {
  const productionBom = useLoaderData();

  return (
    <ProductionBomShowView
      productionBom={productionBom}
      role="operator"
    />
  );
}
